import { createSignal, createEffect, onCleanup } from 'solid-js';
import dayjs from 'dayjs';

// Module-scoped so every caller shares one signal: the timeslider writes the
// selected time and any panel reads the same value, rather than each invocation
// getting a private signal that never propagates anywhere (EID-59).
const [globalTime, setGlobalTime] = createSignal(null);

const useGlobalTime = () => {
  return { globalTime, setGlobalTime };
};

const useTimer = () => {
  const [timer, setTimer] = createSignal(0);
  const [intervalTime, setIntervalTime] = createSignal(600);
  createEffect(() => {
    const seconds = intervalTime();
    const interval = setInterval(
      () => setTimer((_timer) => _timer + seconds),
      seconds * 1000,
    );
    // Solid idiom: cleanup is registered with onCleanup, not returned.
    // Runs before each re-run (intervalTime change) and on owner disposal,
    // so the previous interval never keeps ticking.
    onCleanup(() => clearInterval(interval));
  });
  return { timer, setIntervalTime };
};

export { useGlobalTime, useTimer };
